import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Table } from "antd";
import TableAntd from "components/elements/Table/Table";

const EmployeeList = ({
  onChange = () => { },
  isLoading = false,
  pagination = {},
  dataSource = [],
}) => {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const columns = [
    {
      title: <div className="text-table">{t('workin.date')}</div>,
      dataIndex: "date",
      key: "date",
      align: "center",
    },
    {
      title: <div className="text-table">{t('workin.1st-time')}</div>,
      dataIndex: "firstTime",
      key: "firstTime",
    },
    {
      title: <div className="text-table">{t('workin.2nd-time')}</div>,
      dataIndex: "secondTime",
      key: "secondTime",
    },
    {
      title: <div className="text-table">{t('workin.3rd-time')}</div>,
      dataIndex: "thirdTime",
      key: "thirdTime",
    },
    {
      title: <div className="text-table">{t('workin.4th-time')}</div>,
      dataIndex: "fourthTime",
      key: "fourthTime",
    },
    {
      title: <div className="text-table">{t('workin.5th-time')}</div>,
      dataIndex: "fifthTime",
      key: "fifthTime",
    },
    {
      title: <div className="text-table">{t('workin.6th-time')}</div>,
      dataIndex: "sixthTime",
      key: "sixthTime",
    },
    {
      title: <div className="text-table">{t('workin.7th-time')}</div>,
      dataIndex: "seventhTime",
      key: "seventhTime",
    },
    {
      title: <div className="text-table">{t('workin.8th-time')}</div>,
      dataIndex: "eighth",
      key: "eighth",
    },
    {
      title: <div className="text-table">{t('workin.9th-time')}</div>,
      dataIndex: "ninth",
      key: "ninth",
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default EmployeeList;
